import { Routes } from '@angular/router'
import { isLoggedInGuard, isNotLoggedInGuard, setURLStateFromQuery } from '@guards'

export const routes: Routes = [
	{
		path: '',
		loadComponent: () => import('./pages/main.component').then(m => m.MainComponent),
		canActivateChild: [isNotLoggedInGuard],
		loadChildren: () => import('./pages/main.routes').then(m => m.MAIN_ROUTES)
	},
	{
		path: 'login',
		canActivate: [isLoggedInGuard],
		loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
	},
	{
		path: 'verification',
		canActivate: [setURLStateFromQuery],
		loadComponent: () =>
			import('./pages/verification/verification-email/verification-email.component').then(
				m => m.VerificationEmailComponent
			)
	},
	{
		path: 'password',
		canActivate: [setURLStateFromQuery],
		loadComponent: () => import('./pages/verification/password/password.component').then(m => m.PasswordComponent)
	}
]
